import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-bottom-navigation-modal',
    templateUrl: './bottom-navigation-modal.component.html',
    styleUrls: ['./bottom-navigation-modal.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomNavigationModalComponent implements OnInit {
  @Input() page: any;
  @Input() selectedTheme: string;
  @Input() selectedSubMenu: any;
  @Output() selectedPage= new EventEmitter<any>();

  constructor() { }

  ngOnInit() {}

  navigateTo(page: any) {
    this.selectedPage.emit(page);
  }

}
